<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          โครงการที่ได้รับการจัดสรร
        </div>
        <div class="d-flex align-center">
          <Iconify
              icon="icon-park-solid:inbox-download-r"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          <div>โครงการที่ได้รับการจัดสรร</div>
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
                clearable
                :items="statusMaster"
                @onChange="searchData.status = $event; getFormCList()"
            ></SelectBox>
          </div>
          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
                @onChange="searchData.keyword = $event"
                @onEnter="getFormCList()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <AllocatedProjectItem
            v-for="(item, i) in plans"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
            @onUpdateStatus="(status) => onUpdateStatus(status, item.id)"
        ></AllocatedProjectItem>
      </div>
      <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getFormCList"
    ></v-pagination>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import SelectBox from "../../components/input/SelectBox"
import AllocatedProjectItem from "../../components/AllocatedProjectItem"
import { mapState } from "vuex"

export default {
  name: "AllocatedProjectList",
  components: {
    TextField,
    SelectBox,
    AllocatedProjectItem
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'รหัสโครงการ',
          width: '12%'
        },
        {
          name: 'ชื่อโครงการ',
          width: '27%'
        },
        {
          name: 'เเผนงานที่ยื่น',
          width: '27%'
        },
        {
          name: 'ผู้นำเข้าข้อมูล',
          width: '13%'
        },
        {
          name: 'สถานะ',
          width: '13%'
        }
      ],
      plans: [
      ],
      statusMaster: [
          'Inception',
          'Submitted2',
          'Approved',
          'Completed'
      ],
      searchData: {
        status: null,
        keyword: null
      },
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    }
  },
  created () {
    this.getFormCList()
  },
  computed: {
    ...mapState({
      isUSP: state => state.Auth.User.user_type === 'USP',
      isRSP: state => state.Auth.User.user_type === 'RSP'
    })
  },
  methods: {
    async getFormCList (page) {
      let res
      let payload = {
        status: this.searchData.status ?? this.statusMaster.join(','),
        keyword: this.searchData.keyword
      }
      res = await this.$apiFire('CForm/getFormCList', payload)
      console.log(res)
      this.plans = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    },
    async onUpdateStatus (status, id) {
      let payload = {
        id,
        payload: {
          status
        }
      }

      console.log('payload updated: ', payload)
      let res = await this.$apiFire('CForm/updateFormC', payload)
      console.log(res)
      this.getFormCList()
    }
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

</style>